import _createForOfIteratorHelper from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _toConsumableArray from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectSpread from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _classCallCheck from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/esnext.iterator.some.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { __decorate } from "tslib";
import path from 'path';
import { Component, Vue, Watch } from 'vue-property-decorator';
import { PermissionModule } from '@/store/modules/permission';
import { TagsViewModule } from '@/store/modules/tags-view';
import ScrollPane from './ScrollPane.vue';
var default_1 = /*#__PURE__*/function (_Vue) {
  function default_1() {
    var _this;
    _classCallCheck(this, default_1);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, default_1, [].concat(args));
    _defineProperty(_this, "visible", false);
    _defineProperty(_this, "top", 0);
    _defineProperty(_this, "left", 0);
    _defineProperty(_this, "selectedTag", {});
    _defineProperty(_this, "affixTags", []);
    return _this;
  }
  _inherits(default_1, _Vue);
  return _createClass(default_1, [{
    key: "visitedViews",
    get: function get() {
      return TagsViewModule.visitedViews;
    }
  }, {
    key: "routes",
    get: function get() {
      return PermissionModule.routes;
    }
  }, {
    key: "onRouteChange",
    value: function onRouteChange() {
      this.addTags();
      this.moveToCurrentTag();
    }
  }, {
    key: "onVisibleChange",
    value: function onVisibleChange(value) {
      if (value) {
        document.body.addEventListener('click', this.closeMenu);
      } else {
        document.body.removeEventListener('click', this.closeMenu);
      }
    }
  }, {
    key: "mounted",
    value: function mounted() {
      this.initTags();
      this.addTags();
    }
  }, {
    key: "isActive",
    value: function isActive(route) {
      return route.path === this.$route.path;
    }
  }, {
    key: "filterAffixTags",
    value: function filterAffixTags(routes) {
      var _this2 = this;
      var basePath = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '/';
      var tags = [];
      routes.forEach(function (route) {
        if (route.meta && route.meta.affix) {
          var tagPath = path.resolve(basePath, route.path);
          tags.push({
            fullPath: tagPath,
            path: tagPath,
            name: route.name,
            meta: _objectSpread({}, route.meta)
          });
        }
        if (route.children) {
          var childTags = _this2.filterAffixTags(route.children, route.path);
          if (childTags.length >= 1) {
            tags = [].concat(_toConsumableArray(tags), _toConsumableArray(childTags));
          }
        }
      });
      return tags;
    }
  }, {
    key: "initTags",
    value: function initTags() {
      this.affixTags = this.filterAffixTags(this.routes);
      var _iterator = _createForOfIteratorHelper(this.affixTags),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var tag = _step.value;
          // Must have tag name
          if (tag.name) {
            TagsViewModule.addVisitedView(tag);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "addTags",
    value: function addTags() {
      var name = this.$route.name;
      if (name) {
        TagsViewModule.addView(this.$route);
      }
      return false;
    }
  }, {
    key: "moveToCurrentTag",
    value: function moveToCurrentTag() {
      var _this3 = this;
      var tags = this.$refs.tag; // TODO: better typescript support for router-link
      this.$nextTick(function () {
        var _iterator2 = _createForOfIteratorHelper(tags),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var tag = _step2.value;
            if (tag.to.path === _this3.$route.path) {
              _this3.$refs.scrollPane.moveToTarget(tag);
              // When query is different then update
              if (tag.to.fullPath !== _this3.$route.fullPath) {
                TagsViewModule.updateVisitedView(_this3.$route);
              }
              break;
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      });
    }
  }, {
    key: "refreshSelectedTag",
    value: function refreshSelectedTag(view) {
      var _this4 = this;
      TagsViewModule.delCachedView(view);
      var fullPath = view.fullPath;
      this.$nextTick(function () {
        _this4.$router.replace({
          path: '/redirect' + fullPath
        });
      });
    }
  }, {
    key: "closeSelectedTag",
    value: function closeSelectedTag(view) {
      TagsViewModule.delView(view);
      if (this.isActive(view)) {
        this.toLastView(TagsViewModule.visitedViews, view);
      }
    }
  }, {
    key: "closeOthersTags",
    value: function closeOthersTags() {
      this.$router.push(this.selectedTag);
      TagsViewModule.delOthersViews(this.selectedTag);
      this.moveToCurrentTag();
    }
  }, {
    key: "closeAllTags",
    value: function closeAllTags(view) {
      var _this5 = this;
      TagsViewModule.delAllViews();
      if (this.affixTags.some(function (tag) {
        return tag.path === _this5.$route.path;
      })) {
        return;
      }
      this.toLastView(TagsViewModule.visitedViews, view);
    }
  }, {
    key: "toLastView",
    value: function toLastView(visitedViews, view) {
      var latestView = visitedViews.slice(-1)[0];
      if (latestView) {
        this.$router.push(latestView);
      } else {
        // Default redirect to the home page if there is no tags-view, adjust it if you want
        if (view.name === 'Dashboard') {
          // to reload home page
          this.$router.replace({
            path: '/redirect' + view.fullPath
          });
        } else {
          this.$router.push('/');
        }
      }
    }
  }, {
    key: "openMenu",
    value: function openMenu(tag, e) {
      var menuMinWidth = 105;
      var offsetLeft = this.$el.getBoundingClientRect().left; // container margin left
      var offsetWidth = this.$el.offsetWidth; // container width
      var maxLeft = offsetWidth - menuMinWidth; // left boundary
      var left = e.clientX - offsetLeft + 15; // 15: margin right
      if (left > maxLeft) {
        this.left = maxLeft;
      } else {
        this.left = left;
      }
      this.top = e.clientY;
      this.visible = true;
      this.selectedTag = tag;
    }
  }, {
    key: "closeMenu",
    value: function closeMenu() {
      this.visible = false;
    }
  }]);
}(Vue);
__decorate([Watch('$route')], default_1.prototype, "onRouteChange", null);
__decorate([Watch('visible')], default_1.prototype, "onVisibleChange", null);
default_1 = __decorate([Component({
  name: 'TagsView',
  components: {
    ScrollPane: ScrollPane
  }
})], default_1);
export default default_1;